module.exports = __webpack_public_path__ + "img/10_24.4e1043a2.png";